import { giphyBlack, giphyCharcoal, giphyDarkGrey } from '@giphy/colors'
import { ReactNode, useMemo } from 'react'
import IconComponent from 'ui/src/components/icon'
import type Icon from 'ui/src/types/icons'
import { brightnessFromColor } from 'utils'
import ColorPanel from '../../../../color-panel'
import { Subheading } from '../../style'
import { ColorButton, TooltipContent } from './style'

type Props = {
    buttonColor?: string
    className?: string
    children?: ReactNode
    color?: string
    icon: Icon
    label: string
    onChange?: (color: string) => void
}

const UGECaptionsEditorColor = ({
    buttonColor = giphyBlack,
    className,
    children,
    color,
    icon,
    label,
    onChange,
}: Props) => {
    const isDark = useMemo(() => {
        if (!color) return false

        const brightness = brightnessFromColor(color)
        const minBrightness = brightnessFromColor(giphyDarkGrey)

        return brightness <= minBrightness
    }, [color])

    return (
        <ColorButton
            $isDark={isDark}
            className={className}
            dropdownOptions={{ width: 520 }}
            iconButtonOptions={{ color: buttonColor }}
            label={<IconComponent color={color || giphyCharcoal} height={34} icon={icon} width={34} />}
            labelStyle={{ padding: 0 }}
        >
            <TooltipContent>
                {children}
                <ColorPanel color={color} swatchLabel={<Subheading>{label}</Subheading>} onChange={onChange} />
            </TooltipContent>
        </ColorButton>
    )
}

export default UGECaptionsEditorColor
